<template>

  <div>

    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control"
               @keypress.enter="find()"
               v-model="query.generic"
               placeholder="Pesquisar por nome ou e-mail">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline"
              :class="{ 'btn-outline-active': showFilter }"
              @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
                      :amount-changed="updateNumberOfBadges"
                      :filters="[filterPeriodType, filterStartDate, filterEndDate]"/>
      </div>
    </div>

    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label for="period-type">Tipo de período</label>
          <select v-model="query.periodType" id="period-type" class="form-control">
            <option value="created_at">Criado em</option>
            <option value="updated_at">Atualizado em</option>
            <option value="last_sign_in_at">Penúltimo login</option>
            <option value="current_sign_in_at">Último login</option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-3">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>

        <div class="col-md-3">
          <label for="user-order">Ordenar por</label>
          <select id="user-order" class="form-control" @change="updateOrder($event)">
            <option value="1">Criação descendente</option>
            <option value="2">Criação ascendente</option>
            <option value="3">Atualização descendente</option>
            <option value="4">Atualização ascendente</option>
            <option value="5">Nome descendente</option>
            <option value="6">Nome ascendente</option>
          </select>
        </div>
      </div>
    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button
          class="btn btn-primary mt-1 mr-1"
          @click="createReport"
          :disabled="disabledReport"
        >
          Baixar relatório
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong class="mr-3">
              {{infoTotalModels}}
            </strong>

            <button
              class="btn btn-outline ml-3 mb-1"
              v-if="users.length > 0"
              @click="changeCheckAll"
              :class="{ 'btn-outline-active': checkAll}"
            >
              {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
            </button>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>
                <BkpsCheckBox :value="checkAllRow" @input="changeCheckAllRow"/>
              </th>
              <th>ID</th>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Contas</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th>Penúltimo login</th>
              <th>Último login</th>
              <th>Quantidade de logins</th>
              <th>Admin</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>
                <BkpsCheckBox v-model="user.checked" @input="changeCheckRow"/>
              </td>
              <td>{{ user.id }}</td>
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.accountCount }}</td>
              <td>{{ user.createdAt | datetime }}</td>
              <td>{{ user.updatedAt | datetime }}</td>
              <td v-if="user.lastSignInAt">{{ user.lastSignInAt | datetime }}</td>
              <td v-else>Nunca</td>
              <td v-if="user.currentSignInAt">{{ user.currentSignInAt | datetime }}</td>
              <td v-else>Nunca</td>
              <td>{{ user.signInCount }}</td>
              <td>{{ user.superUser ? 'Sim' : 'Não' }}</td>
              <td>
                <div class="btn-group">
                  <button @click="showUser(user)" class="btn btn-outline">Ver</button>
                  <button class="btn btn-outline" @click="sendToShow(user)">Detalhes</button>
                  <button v-if="user.id !== getUser.id"
                    @click="impersonate(user)"
                    class="btn btn-primary">Impersonar</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

    <!-- User Details Modal -->
    <ShowDataModal
      v-if="currentUser"
      v-model="showModal"
      :header="currentUser.email"
      :data="currentUser"
      :deep="2"
    />

  </div>

</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import CheckedModels from '@/mixins/CheckedModels'
  import GetUser from '@/mixins/GetUser'
  import { notifySessionChanged } from '@/utils/sessionChannel'
  import GlobalLoading from '@/mixins/GlobalLoading'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ShowDataModal from '@/components/admin/ShowDataModal'
  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import {Filter} from '@/models/filter'

  export default {
    components: {
      BadgeFilters,
      BkpsCheckBox,
      ChevronDownIcon,
      Pagination,
      SearchIcon,
      ShowDataModal
    },
    computed: {
      users() {
        return this.getModels || []
      },
      disabledReport() {
        return this.meta.totalCount === 0 || (!this.checkAll && !this.users.some(u => u.checked))
      }
    },
    created() {
      this.defaultModelSetting.updateQueryURL = true
      this.$set(this.query, 'periodType', 'created_at')
      this.order.push('created', 'desc')
      this.includes.push('accounts')
      this.methods.push('tokens')
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })
    },
    data: () => ({
      currentUser: null,
      filterPeriodType: new Filter({
        key: 'periodType',
        label: 'Tipo de período',
        table: [
          ['Criado em', 'created_at'],
          ['Atualizado em', 'updated_at'],
          ['Penúltimo login', 'last_sign_in_at'],
          ['Último login', 'current_sign_in_at']
        ]
      }),
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      modelPathPrefix: 'admin',
      nameModel: 'User',
      showModal: false
    }),
    methods: {
      find() {
        this.asyncTemplateSelect()
      },
      impersonate(user) {
        if (!(confirm('Tem certeza?')))
          return

        this.$ls.clear()
        this.axios.post(`/admin/users/${user.id}/impersonate`)
          .then(() => {
            notifySessionChanged()
            location.href = '/'
          })
          .catch(e => this.$notify.addError(e))
      },
      showUser(user) {
        this.currentUser = user
        this.showModal = true
      },
      updateOrder(event) {
        const option = event.target.value

        const [name, order] = {
          '1': ['created_at', 'desc'],
          '2': ['created_at', 'asc'],
          '3': ['updated_at', 'desc'],
          '4': ['updated_at', 'asc'],
          '5': ['name', 'desc'],
          '6': ['name', 'asc'],
        }[option]

        this.order = [name, order]
      },
      changeCheckAll() {
        this.changeCheck({ checkAll: !this.checkAll, sources: this.users })
      },
      changeCheckAllRow(value) {
        this.changeCheck({ checkAllRow: value, sources: this.users })
      },
      changeCheckRow() {
        this.changeCheck({ sources: this.users })
      },
      createReport() {
        let params
        let amount

        if (this.checkAll) {
          params = this.buildParams()
          amount = this.meta.totalCount
        } else {
          const ids = this.users.filter(u => u.checked).map(u => u.id)
          params = { q: { id: ids } }
          amount = ids.length
        }

        if (!confirm(`Exportar ${amount} Usuário(s).\nTem certeza?`))
          return

        this.openGlobalLoad()
        this.axios.get('admin/users/report', {params})
          .then(response => {
            if (response.data)
              this.$parse.downloadByLink(response.data)
            else
              this.$notify.add(response.meta.notice)
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())
      },
      sendToShow(user) {
        this.$ls.set(`adminUserShow${user.id}`, user, { minutes: 1 })
        const resolvedRoute = this.$router.resolve(`/admin/users/${user.id}`)
        window.open(resolvedRoute.href, '_blank');
      }
    },
    mixins: [CheckedModels, ModelMapper, GetUser, GlobalLoading],
    name: 'User'
  }
</script>

<style scoped>
</style>
